<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:21:26
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:17:21
-->
<template>
  <div>
    <div class="top">
      <div class="top-btn">
        <el-button
         v-if="codeData.indexOf('68') != -1"
          @click="add"
          type="primary"
          >添加主题</el-button
        >
      </div>
      <div class="search">
        <a-input
          v-model="seachValue"
          placeholder="热门主题内容"
          style="width: 173px"
        />
        <el-button style="margin-left: 12px" type="primary" @click="search"
          >查询</el-button
        >
      </div>
    </div>
    <coententTable
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
      :customSlot="customSlot"
      :loading="loading"
      :y="height"
      @handleSizeChange="handleSizeChange"
    >
      <template v-slot:collectStatus="scopeVal">
        <div
          :class="[
            scopeVal.scope.collectStatus == 1
              ? 'collectStatus1'
              : scopeVal.scope.collectStatus == 2
              ? 'collectStatus2'
              : '',
          ]"
        >
          {{
            scopeVal.scope.collectStatus == 0
              ? "未开始"
              : scopeVal.scope.collectStatus == 1
              ? "进行中"
              : "已结束"
          }}
        </div>
      </template>
      <template v-slot:interviewStartTime="scopeVal">
        <div>
          {{ scopeVal.scope.interviewStartTime }} 至
          {{ scopeVal.scope.interviewEndTime }}
        </div>
      </template>
      <template v-slot:sort="scopeVal">
        <div class="sort">
          <div class="sort-box">
            <img
              v-if="codeData.indexOf('200') != -1"
              @click="sort(scopeVal.scope, true)"
              class="img"
              src="@/assets/images/up.jpg"
            />
          </div>
          <input disabled v-model="scopeVal.scope.sort" class="sort-style" />
          <div class="sort-box-two">
            <img
              v-if="codeData.indexOf('200') != -1"
              @click="sort(scopeVal.scope, false)"
              class="img"
              src="@/assets/images/down.png"
            />
          </div>
        </div>
      </template>
      <template v-slot:displayStatus="scopeVal">
        <a-switch
           v-if="codeData.indexOf('197') != -1"
          :v-model="scopeVal.scope.whetherEnable"
          :checked="scopeVal.scope.whetherEnable ? true : false"
          @change="(checked) => changeDisplayStatus(checked, scopeVal.scope.id)"
        />
      </template>
      <template v-slot:operation="scopeVal">
          <div style="display: flex">
              <div class="btnTwo" style="margin-right: 14px"  v-if="codeData.indexOf('198') != -1" @click="editAdmin(scopeVal.scope)">编辑</div>
              <div
                @click="open(scopeVal.scope)"
                class="btnThree"
                v-if="codeData.indexOf('199') != -1"
                >删除</div
              >
          </div>
      </template>
    </coententTable>
    <el-dialog
      title="确认删除主题?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="handleClose"
      top="17%"
    >
      <span
        >请确认是否继续删除操作。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteOne()">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="ruleForm.id?'编辑热门主题':'添加热门主题'"
      :visible.sync="answersShow"
      v-if="answersShow"
      width="535px"
      class="column-box"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >将在门户网站智能问答平台中显示已启用的热门主题
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="热门主题" prop="hotTheme">
          <el-input
            v-model="ruleForm.hotTheme"
            placeholder="请输入热门主题"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="whetherEnable">
        <div class="status">
          <el-radio v-model="ruleForm.whetherEnable" :label="1">开启</el-radio>
          <el-radio v-model="ruleForm.whetherEnable" :label="0">停用</el-radio>
        </div>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="answersShow = false">取 消</el-button>
        <el-button :loading="submitShow" size="medium" type="primary" @click="tihuan">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {
  findListPage,
  updateDisplayStatus,
  collectDelete,
  saveHotTheme,
  updateHotTheme,
  updateHotSort,
} from "../../index";
export default {
  components: {
    coententTable,
  },
  data() {
    return {
      seachValue: "",
      submitShow:false,
      deleteShow:false,
      columns: [
        {
          title: "热门主题",
          dataIndex: "hotTheme",
          ellipsis: true,
          customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
        },
        {
          title: "排序",
          dataIndex: "interviewStartTime",
          scopedSlots: { customRender: "sort" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "是否启用",
          dataIndex: "whetherEnable",
          scopedSlots: { customRender: "displayStatus" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 174,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "displayStatus",
          customRender: "displayStatus",
        },
        {
          name: "sort",
          customRender: "sort",
        },
      ],
      loading: false,
      height: 0,
      collectTheme: "", //
      collectUnit: "",
      dialogVisibleTwo: false,
      item: {},
      seeData: [],
      answersShow:false,
      ruleForm:{},
      codeData:[],
      rules: {
        hotTheme: [
          { required: true, message: "请输入热门主题", trigger: "blur" }, 
        ],
        whetherEnable: { required: true, message: "请选择是否启用", trigger: "blur" } ,
      },
    };
  },
  mounted() {
    this.getListPage();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    add() {
       this.answersShow = true;
       if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields();
            }
       this.ruleForm = {};
    },
    tihuan(){
        this.submitShow = true;
        this.$refs.ruleForm.validate((valid) => {
            if(valid){
              if(this.ruleForm.id){
            updateHotTheme({
            siteId:sessionStorage.getItem('siteId'),
            ...this.ruleForm,
        }).then((res)=>{
            if(res.code == 0){
                this.getListPage();
                this.answersShow = false;
            }
            this.submitShow = false;
        })
        }else{
            saveHotTheme({
            siteId:sessionStorage.getItem('siteId'),
            ...this.ruleForm,
        }).then((res)=>{
            if(res.code == 0){
                this.getListPage();
                this.answersShow = false;
            }
             this.submitShow = false;
        })
        }
            }else{
              this.submitShow = false;
            }
        })
        
        
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisibleTwo = true;
    },
    handleClose() {
      this.dialogVisibleTwo = false;
    },
    search() {
      this.pagination.current = 1;
      this.getListPage();
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getListPage();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getListPage();
    },
    getListPage() {
      const _this = this;
      _this.loading = true;
      let reqData = {
        current: _this.pagination.current,
        siteId: sessionStorage.getItem("siteId"),
        size: _this.pagination.pageSize,
        hotTheme:_this.seachValue,
      };
      findListPage(reqData).then((res) => {
        if (res.code == 0) {
          _this.dataSource = res.data.records;
          _this.pagination.current = res.data.current;
          _this.pagination.total = res.data.total;
          if(_this.pagination.total > 0){
            this.height = document.documentElement.clientHeight - 500;
            window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 500;
              })();
            };
          }
          _this.pagination.pageSize = res.data.size;
          _this.loading = false;
        }
      });
    },
    changeDisplayStatus(displayStatus, id) {
      updateDisplayStatus({
        whetherEnable: displayStatus ? 1 : 0,
        id: id,
      }).then((res) => {
        if (res.code == 0) {
          this.getListPage();
        }
      });
    },
    deleteOne() {
      this.deleteShow = true;
      collectDelete({ id: this.item.id,siteId:sessionStorage.getItem('siteId') }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.getListPage();
        }
      });
    },
    editAdmin(item) {
       this.ruleForm = item;
       this.answersShow = true;
       if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields();
            }
    },
    sort(item,type){
        updateHotSort({
            id:item.id,
            type,
        }).then((res)=>{
            if(res.code == 0){
                this.getListPage();
            }
        })
    }
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
   .search {
            display: flex;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.collectStatus1 {
  color: #1890ff;
}
.collectStatus2 {
  color: #909399;
}
/deep/.ant-switch-checked {
  background-color: #39d362;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 24px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.column-box{
  /deep/ .el-dialog__body{
    padding-bottom: 5px;
    padding-top: 10px;
  }
}
.el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>